/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Field_Pix_KeyInputs */

const en_clients_field_pix_key = /** @type {(inputs: Clients_Field_Pix_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PIX Key`)
};

const pt_br2_clients_field_pix_key = /** @type {(inputs: Clients_Field_Pix_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chave PIX`)
};

/**
* | output |
* | --- |
* | "PIX Key" |
*
* @param {Clients_Field_Pix_KeyInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_field_pix_key = /** @type {((inputs?: Clients_Field_Pix_KeyInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Field_Pix_KeyInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_field_pix_key(inputs)
	return pt_br2_clients_field_pix_key(inputs)
});